import { UnitSystem, BfMetricTileType, BfMetricTileSize } from '@trackman/baseball-shared-components';

export const convertDisplayUnits = (unitSystem: UnitSystem, tileType: BfMetricTileType, tileSize: BfMetricTileSize): string => {
  switch (tileType) {
    case BfMetricTileType.releaseSpeed:
    case BfMetricTileType.exitSpeed:
    case BfMetricTileType.effectiveVelocity:
    case BfMetricTileType.speedDrop:
      return unitSystem === UnitSystem.Imperial ? 'Mph' : 'Kph';
    case BfMetricTileType.extension:
    case BfMetricTileType.plateSide:
    case BfMetricTileType.plateHeight:
    case BfMetricTileType.distance:
    case BfMetricTileType.maxHeight:
    case BfMetricTileType.releaseHeight:
    case BfMetricTileType.releaseSide:
    case BfMetricTileType.verticalBreak:
      if (unitSystem === UnitSystem.Imperial) {
        return tileSize === BfMetricTileSize.Small ? 'ft, in' : 'Feet, Inches';
      }
      return tileSize === BfMetricTileSize.Small ? 'm' : 'Meters';

    case BfMetricTileType.inducedVerticalBreak:
    case BfMetricTileType.horizontalBreak:
      if (unitSystem === UnitSystem.Imperial) {
        return tileSize === BfMetricTileSize.Small ? 'in' : 'Inches';
      }
      return tileSize === BfMetricTileSize.Small ? 'cm' : 'Centimeters';

    case BfMetricTileType.spinRate:
    case BfMetricTileType.hitSpinRate:
      return 'Rpm';
    case BfMetricTileType.verticalRelease:
    case BfMetricTileType.horizontalApproach:
    case BfMetricTileType.exitAngle:
    case BfMetricTileType.bearing:
    case BfMetricTileType.direction:
    case BfMetricTileType.horizontalRelease:
    case BfMetricTileType.spinAxis:
    case BfMetricTileType.verticalApproach:
      return tileSize === BfMetricTileSize.Small ? 'Deg' : 'Degrees';
    case BfMetricTileType.timeOfFlight:
    case BfMetricTileType.hangTime:
      return tileSize === BfMetricTileSize.Small ? 's' : 'Seconds';
    default:
      return '';
  }
};
